import { CommonModule } from '@angular/common';
import { AuthService } from './../../Services/auth.service';
import { TutorialService } from './../../Services/tutorial.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UploadService } from '../../Services/upload.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-tuturial-edit',
  template: require('./tuturial-edit.component.html'),
  styles: [require('./tuturial-edit.component.css')]
})
export class TuturialEditComponent implements OnInit {
  @ViewChild("fileInputVideo") fileInputVideo: ElementRef;
  @ViewChild("fileInputImage") fileInputImage: ElementRef;
  editor_modules: any = {};
  editItem: any = {};
  videoWidth = "340";
  
  

  constructor(private uploadService: UploadService, private tutorialService:TutorialService, private route: ActivatedRoute, private router: Router, private auth: AuthService) { 
    this.editor_modules = {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        // ['blockquote', 'code-block'],
  
        // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction
  
        // [{ 'size': ['small', false, 'large', 'huge'] }],
        // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        // [{ 'font': [] }],
        [{ 'align': [] }],
  
        ['clean'],                                         // remove formatting button
        ['link']
        //['link', 'image', 'video']                         // link and image, video
      ]
    }
    route.params.subscribe(p => {
      if (p['id']) {
        this.editItem.id = +p['id'];
      }
      else {
        this.editItem.id = -1;
      }
    });
  }

  ngOnInit() {
    this.newOtherItem();
    if (this.editItem.id > -1){
      this.tutorialService.getItemById(this.editItem.id).subscribe(res =>{
        this.editItem = res;       
      });
    }
  }

  SaveTutorial(){
    if (this.editItem.id <= 0){
      this.tutorialService.create(this.editItem).subscribe( res => {
        // console.log(res);
      })
    }
    else{
      this.tutorialService.update(this.editItem).subscribe (res => {
        // console.log(res);
      })
    }
    this.router.navigate(['/tutorials']);
  }


  newOtherItem() {
    // console.log("in new other:"+this.position);
    // this.editItem = {
    this.editItem.title= "";
    this.editItem.content= "";   
    this.editItem.image = "";
    this.editItem.video= "";    
    this.editItem.url = "";
    // }
    // console.log(this.editItem)
  }

  uploadVideo() {
    var nativeElement: HTMLInputElement = this.fileInputVideo.nativeElement;
    if (nativeElement != null) {
      var files = nativeElement.files;
      if (files != null) {
        var file = files[0];
        // console.log("Upload file: ")
        // console.log(file.name);
        this.uploadService.uploadFileToTutorials(file).subscribe(x => {
          console.log(x);
          
          this.editItem.video = x.filename;
        })
      }
    }
  }

  removeVideo(image:any){
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.uploadService.deleteFileFromTutorials(this.editItem.video).subscribe( x => {
            // console.log(x);
            this.editItem.video = ""
          })
        }
      });
  }

  uploadImage() {
    var nativeElement: HTMLInputElement = this.fileInputImage.nativeElement;
    if (nativeElement != null) {
      var files = nativeElement.files;
      if (files != null) {
        var file = files[0];
        // console.log("Upload file: ")
        // console.log(file.name);
        this.uploadService.uploadFileToTutorials(file).subscribe(x => {
          console.log(x);
          
          this.editItem.image = x.filename;
        })
      }
    } 
  }

  removeImage(image:any){
    Swal.fire({
        title: 'Ben je zeker?',
        text: "Ben je zeker dat je dit wil verwijderen?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jep',
        cancelButtonText: 'Nope'
      }).then((result) => {
        if (result.value) {
          this.uploadService.deleteFileFromTutorials(this.editItem.image).subscribe( x => {
            // console.log(x);
            this.editItem.image = ""
          })
        }
      });
  }
  playMovie(id: string){
    // console.log(id);
    this.swapImageVideoforId(id);
    let elem =  document.getElementById("video-"+id);
    if (elem !=null){
      let video = <HTMLMediaElement> elem;
      video.play();
    }
  }

  videoEnded(id: string){
    // console.log('Video ended:'+id);
    this.swapImageVideoforId(id);

    // https://stackoverflow.com/questions/40535014/angular2-how-to-get-reference-of-html-elements-generated-dynamically/41306286
  }

  readMore(){
    if (this.editItem.content.length > 0){
      Swal.fire({
        title: "<i>"+this.editItem.title+"</i>", 
        html: this.editItem.content ,  
        confirmButtonColor: '#3085d6',
        confirmButtonText: "Ok", 
      });
    }
  }

  IsThereMoreToRead(length: number){
    if (this.editItem.content != null){
      if (this.editItem.content.length > length ){
        return true
      }
      else {
        return false
      }
    }else{
      this.editItem.content = "";
      return false;
    }
  }
  

  private swapImageVideoforId(id: string){
    let thumbnail_elem = document.getElementById("thumbnail-"+id);
    let video_elem = document.getElementById("video-"+id);
    let overlay_elem = document.getElementById("overlay-"+id)
    // console.log(thumbnail_elem);
    // console.log(video_elem);

    if (thumbnail_elem != null && video_elem != null && overlay_elem != null){
      thumbnail_elem.hidden = !thumbnail_elem.hidden;
      video_elem.hidden = !video_elem.hidden;
      overlay_elem.hidden = !overlay_elem.hidden;
    }
  }



  // getFilenameType(filename: string){
  //   var ext = "";
  //   var res = ""
  //   if (filename.length > 0){
  //     ext = filename.substr(filename.lastIndexOf('.')+1,3).toLowerCase()
  //     switch (ext) {
  //       case "mp4":
  //         res = "video";        
  //         break;
  //       case "":
  //         res =  "none";
  //         break;
        
  //       case "jpg":
  //       case "jpeg":
  //       case "png":
  //       case "gif":
  //         res =  "image";
  //         break;
  //       default:
  //         res =  "none"
  //         break;
  //     }
  //   }
  //   return res;

  // }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/tuturial-edit/tuturial-edit.component.ts